
export default {
  props: {
    value: {
      type: Boolean
    }
  },

  computed: {
    active: {
      get () {
        return this.value;
      },

      set (value) {
        this.$emit('input', !this.value);
      }
    }
  }
};
